export const EDITING_STARTED = 'ui/EDITING_STARTED'
export const EDITING_ENDED = 'ui/EDITING_ENDED'
export const NOTIFY_SERVER_EDITING_ENDED = 'ui/NOTIFY_SERVER_EDITING_ENDED'
export const EDIT_COMMITTED = 'ui/EDIT_COMMITTED'
export const USER_DISCONNECTED = 'ui/USER_DISCONNECTED'



// WEBPACK FOOTER //
// ./state/types/editing.js